import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Button } from 'antd'
import { apiConfig, apiGetPage } from '../../request/api'
import { RootState } from '../../store/index';
import { useCustomData } from '../../pages/context/indexCustomDataContext';
import '../../assets/css/home.css'

const HomePart3: React.FC = () => {
    const themeColor = useSelector((state: RootState) => state.themeColor.value);
    const navigate = useNavigate();
    const { getValue } = useCustomData();
    const indexSecondIntroducesFirst = getValue('indexSecondIntroducesFirst');
    const indexSecondIntroducesSecond = getValue('indexSecondIntroducesSecond');
    const indexSecondIntroducesThird = getValue('indexSecondIntroducesThird');
    const indexSecondIntroducesFourth = getValue('indexSecondIntroducesFourth');
    const indexSecondSubTitle = getValue('indexSecondSubTitle');
    const knowMore = getValue('knowMore');
    const indexTitle = getValue('indexTitle');

    return (
        <div className="home-part3">
            <div className='home-part3_left'>   
                <div className='home-part3_left_top'>{indexTitle}</div>
                <div className='home-part3_left_middle'>{indexSecondSubTitle}</div>
                {/* {partList && <div className='home-part3_left_bottom'>{partList.subInfo}</div>} */}
                <div className='home-part3_left_button'>
                    <Button type="primary" onClick={() => navigate('/service', { state: { initialView: 'service-index' } })}>{knowMore}</Button>
                </div>
            </div>
            <div className='home-part3_left'>
                <div className='home-part3_left_item' style={{ 'backgroundColor': themeColor }}>{indexSecondIntroducesFirst}</div>
                <div className='home-part3_left_item' style={{ 'backgroundColor': themeColor }}>{indexSecondIntroducesSecond}</div>
                <div className='home-part3_left_item' style={{ 'backgroundColor': themeColor }}>{indexSecondIntroducesThird}</div>
                <div className='home-part3_left_item' style={{ 'backgroundColor': themeColor }}>{indexSecondIntroducesFourth}</div>
            </div>
        </div>
    );
};

export default HomePart3;